var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-float-container",on:{"click":_vm.goToCart}},[_c('img',{staticClass:"cart-icon",attrs:{"src":"https://oss.turingsenseai.com/1626772772335007776.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }